<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <indexHeader
          :title="$t('Groups Numbering')"
          :description="$t('From Here You Can Control The Numbering Of Your Groups')"
        />
        <indexTable
          :searchText="$t('Search for numbering')"
          :emptyTableText="$t('there Is No Numbering')"
          :localData="true"
          :buttonRole="true"
          :emptyTableSubText="$t('Try adding some items to the table and try again')"
          :cloumns="[
            {
              column: 'name',
              title: $t('The Name'),
              type: 'text',
              sort: true
            },
            {
              column: 'prefix',
              title: $t('The Prefix'),
              type: 'text',
              sort: true
            },
            {
              column: 'next_id',
              title: $t('next Number'),
              type: 'text',
              sort: true
            },
            {
              column: 'left_pad',
              title: $t('Left Margin'),
              type: 'text',
              sort: true
            },
            {
              column: 'prefix_year',
              title: $t('Year Prefix'),
              type: 'trueOrFalse',
              sort: true
            },
            {
              column: 'prefix_month',
              title: $t('The Month Prefix'),
              type: 'trueOrFalse',
              sort: true
            },
            {
              column: 'options',
              title: $t('Settings'),
              type: 'options',
              options: [
                { name: 'edit', role: true },
                { name: 'delete', role: true }
              ]
            }
          ]"
          :deleteText="{
            attention: $t('Attention'),
            areYouReallySureToDeleteTheItem: $t('Are you really sure to delete the item'),
            close: $t('Close'),
            confirm: $t('Confirm'),
            loading: $t('Loading')
          }"
        />
      </div>
    </div>
  </div>
</template>
<script>
import indexHeader from '@/elements/index/indexHeader.vue'
import indexTable from '@/elements/index/indexTable.vue'
export default {
  data() {
    return {
      path: '/invoiceGroups'
    }
  },
  components: {
    indexHeader,
    indexTable
  }
}
</script>
